import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const CircleImageModalAnimation = () => {
  const containers = document.querySelectorAll(".circle-image-modal-section");
  if (containers.length < 1) {
    return;
  }

  const reduceMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;
  if (reduceMotion) return;

  const base = {
    y: 0,
    opacity: 1,
    duration: 1,
    ease: "power2.inOut",
  };
  const applyAnimations = () => {
    containers.forEach((container) => {
      const headline = container.querySelectorAll(
        ".circle-image-modal__headline",
      );
      const subline = container.querySelectorAll(
        ".circle-image-modal__subline",
      );
      const teaserImage = container.querySelectorAll(".teaser-image-container");
      const teaserHeadline = container.querySelectorAll(
        ".circle-image-single__headline",
      );
      const teaserButton = container.querySelectorAll(
        ".circle-image-single__button",
      );
      if (
        !headline.length &&
        !subline.length &&
        !teaserImage.length &&
        !teaserHeadline.length &&
        !teaserButton.length
      )
        return;

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container,
          start: "top 80%",
          once: true,
          fastScrollEnd: true,
        },
      });

      if (headline.length) {
        tl.to(headline, { ...base, x: 0 }, 0);
      }

      if (subline.length) {
        tl.to(subline, { ...base, x: 0 }, 0.2);
      }

      if (teaserImage.length) {
        tl.to(teaserImage, { ...base, scale: 1, stagger: 0.15 }, 0.2);
      }

      if (teaserHeadline.length) {
        tl.to(teaserHeadline, { ...base, stagger: 0.15 }, 0.4);
      }

      if (teaserButton.length) {
        tl.to(
          teaserButton,
          {
            y: 0,
            opacity: 1,
            duration: 0.75,
            ease: "back.out(1.7, 0.5)",
            stagger: 0.15,
          },
          1,
        );
      }
    });
  };
  applyAnimations();
};

export default CircleImageModalAnimation;
